<template>
	<thead>
		<tr>
			<th width="50">#</th>
			<th class="" @click="setOrder('lastName')" v-bind:class="[ this.order_by === 'lastName' ? 'fosorting_' + this.order_type : 'fosorting']">Name</th>
			<th class="" @click="setOrder('email')" v-bind:class="[ this.order_by === 'email' ? 'fosorting_' + this.order_type : 'fosorting']">Email</th>
			<th class="" @click="setOrder('joinedAt')" v-bind:class="[ this.order_by === 'joinedAt' ? 'fosorting_' + this.order_type : 'fosorting']">Join Date</th>
			<th @click="setOrder('totalRecipesCount')" v-bind:class="[ this.order_by === 'totalRecipesCount' ? 'fosorting_' + this.order_type : 'fosorting']">Recipes</th>
			<th @click="setOrder('friendsCount')" v-bind:class="[ this.order_by === 'friendsCount' ? 'fosorting_' + this.order_type : 'fosorting']">Connections</th>
			<th @click="setOrder('lastActiveAt')" v-bind:class="[ this.order_by === 'lastActiveAt' ? 'fosorting_' + this.order_type : 'fosorting']" >Login/Activity</th>
			<th @click="setOrder('disabled')" v-bind:class="[ this.order_by === 'disabled' ? 'fosorting_' + this.order_type : 'fosorting']">Status</th>
			<th width="50" class="text-center " ></th>
		</tr>
	</thead>
</template>

<script>
export default {
	components : {

	},
    props: {
        options : {
        	type: Object,
            required : true
        }
    },
    watch: {
        options : {
        	handler: function (val, oldVal) {
				this.initialize();
			},
			deep: true
        }
    },
    data() {
		return {
			opt : {}
		}
	},

	mounted () {
        this.initialize();
    },
    computed: {
    	order_by : function(){
    		return this.options.order_by
    	},
    	order_type : function(){
    		return this.options.order_type
    	}
    },
    methods : {
    	initialize() {
            this.opt = this.options;
        },
    	setOrder : function(sortby){
    		if (this.opt.order_by === sortby){
                this.opt.order_type = this.opt.order_type === 'asc' ? 'desc' : 'asc'
            }else{
                this.opt.order_by = sortby
                this.opt.order_type = 'asc'
            }
            this.$emit('options:changed', this.opt)
        }
    }
};
</script>